import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=01aa2f24&scoped=true&"
import script from "./Interface.vue?vue&type=script&lang=ts&"
export * from "./Interface.vue?vue&type=script&lang=ts&"
import style0 from "./Interface.vue?vue&type=style&index=0&id=01aa2f24&lang=scss&scoped=true&"
import style1 from "./Interface.vue?vue&type=style&index=1&id=01aa2f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa2f24",
  null
  
)

export default component.exports